import { render } from "./conflicts_of_interest.html?vue&type=template&id=45a34f22&external"
import script from "./conflicts_of_interest.js?vue&type=script&lang=js&external"
export * from "./conflicts_of_interest.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__